import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M12 3c7.2 0 9 1.8 9 9c0 7.2 -1.8 9 -9 9c-7.2 0 -9 -1.8 -9 -9c0 -7.2 1.8 -9 9 -9","key":"svg-0"}]]

/**
 * IconSquareRounded
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItc3F1YXJlLXJvdW5kZWQiCj4KICA8cGF0aCBzdHJva2U9Im5vbmUiIGQ9Ik0wIDBoMjR2MjRIMHoiIGZpbGw9Im5vbmUiIC8+CiAgPHBhdGggZD0iTTEyIDNjNy4yIDAgOSAxLjggOSA5YzAgNy4yIC0xLjggOSAtOSA5Yy03LjIgMCAtOSAtMS44IC05IC05YzAgLTcuMiAxLjggLTkgOSAtOSIgLz4KPC9zdmc+) - https://tabler.io/icons/icon/square-rounded
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconSquareRounded = createReactComponent('outline', 'square-rounded', 'SquareRounded', __iconNode);

export default IconSquareRounded;